import type { ReactNode } from "react";
import { Button, type ButtonProps } from "@/shared/ui";
import { useAiAvailable } from "./useAi";

export interface AiGenerateButtonProps extends Omit<ButtonProps, "icon" | "loading" | "children"> {
  /** AI feature key (e.g. "generate_exercises"): the button is disabled while it is unavailable. */
  feature: string;
  /** The generation request is running. */
  loading?: boolean;
  children?: ReactNode;
}

/**
 * "Tạo bằng AI" button with a sparkle icon. Disabled (with the reason as a
 * tooltip) when the feature or AI as a whole is off; for staff who cannot
 * read the AI config it stays enabled and the server decides.
 */
export function AiGenerateButton({ feature, loading, children = "Tạo bằng AI", disabled, title, variant = "soft", ...rest }: AiGenerateButtonProps) {
  const ai = useAiAvailable(feature);
  const off = !ai.available;
  const hint = off ? ai.reason ?? undefined : title;
  return (
    // A disabled <button> gets no hover events: the wrapper carries the tooltip.
    <span className="ai-button-wrap" title={hint}>
      <Button {...rest} variant={variant} icon="sparkles" loading={loading} disabled={disabled || off}>
        {children}
      </Button>
    </span>
  );
}
